import React from "react";

const BORDER = {
  teal: "border-t-teal-500", blue: "border-t-blue-500", orange: "border-t-orange-500",
  amber: "border-t-amber-500", rose: "border-t-rose-500", emerald: "border-t-emerald-500",
  purple: "border-t-purple-500", sky: "border-t-sky-500",
};
const ICONBG = {
  teal: "bg-teal-50 text-teal-600 dark:bg-teal-950/60 dark:text-teal-400",
  blue: "bg-blue-50 text-blue-600 dark:bg-blue-950/60 dark:text-blue-400",
  orange: "bg-orange-50 text-orange-600 dark:bg-orange-950/60 dark:text-orange-400",
  amber: "bg-amber-50 text-amber-600 dark:bg-amber-950/60 dark:text-amber-400",
  rose: "bg-rose-50 text-rose-600 dark:bg-rose-950/60 dark:text-rose-400",
  emerald: "bg-emerald-50 text-emerald-600 dark:bg-emerald-950/60 dark:text-emerald-400",
  purple: "bg-purple-50 text-purple-600 dark:bg-purple-950/60 dark:text-purple-400",
  sky: "bg-sky-50 text-sky-600 dark:bg-sky-950/60 dark:text-sky-400",
};

export const KpiCard = ({ label, value, sub, color = "orange", Icon, testid, onClick }) => (
  <div
    data-testid={testid}
    onClick={onClick}
    className={`bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 border-t-4 ${BORDER[color]} rounded-lg shadow-sm p-5 transition-all hover:shadow-md ${onClick ? "cursor-pointer hover:-translate-y-0.5" : ""}`}
  >
    <div className="flex items-start justify-between">
      <div className="min-w-0">
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">{label}</p>
        <p className="mt-2 text-2xl xl:text-3xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100 font-mono truncate">{value}</p>
        {sub && <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">{sub}</p>}
      </div>
      {Icon && (
        <div className={`shrink-0 h-10 w-10 rounded-lg flex items-center justify-center ${ICONBG[color]}`}>
          <Icon className="h-5 w-5" />
        </div>
      )}
    </div>
  </div>
);

export default KpiCard;
